import { Slider, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateComponentSettings } from '../../redux/board/reducer';
import { setIsContentChange } from '../../redux/stateManager/reducer';
import { eventBus } from '../../utils';
import './styles.scss';

export default () => {
  const dispatch = useDispatch();
  const activeType = useSelector((state) => state.board.activeType);
  const componentSettings = useSelector((state) => state.board.componentSettings);
  const initialState = {
    opacity: 1,
  };
  const [state, _setState] = useState(initialState);
  const setState = (obj) => _setState((_state) => ({ ..._state, ...obj }));
  const onChange = (e, item) => {
    const value = ['opacity', 'fill'].includes(item) ? e : e.target.value;
    setState({ [item]: value });
    eventBus.emit('save-state-and-progress');
    dispatch(setIsContentChange(true));
    dispatch(updateComponentSettings({ ...state, [item]: value }));
  };
  useEffect(() => {
    if (componentSettings) {
      setState(componentSettings);
    }
  }, [componentSettings]);

  const onOpacityChange = (e) => {
    e.stopPropagation();
    const value = e.target.value.replace(/[^0-9]/g, '');
    eventBus.emit('save-state-and-progress');
    dispatch(setIsContentChange(true));
    if (['0', ''].includes(value)) {
      setState({ opacity: 0 });
      dispatch(updateComponentSettings({ ...state, opacity: 0 }));
      return;
    }
    if (parseFloat(value) > 100) {
      setState({ opacity: 1 });
      dispatch(updateComponentSettings({ ...state, opacity: 1 }));
      return;
    }
    if (parseFloat(value) <= 0) {
      setState({ opacity: 0 });
      dispatch(updateComponentSettings({ ...state, opacity: 0 }));
      return;
    }
    setState({ opacity: parseFloat(value) / 100 });
    dispatch(updateComponentSettings({ ...state, opacity: parseFloat(value) / 100 }));
  };

  return activeType ? (
    <div className="mo__opacity-settings">
      <div className="range">
        <div className="col-2">
          <Slider
            className="slider"
            value={state.opacity}
            min={0}
            max={1}
            step={0.01}
            dots={false}
            onChange={(e) => onChange(e, 'opacity')}
          />
          <div className="value">
            <Tooltip title="Opacity">
              <input
                value={state.opacity * 100}
                onChange={onOpacityChange}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
              />
            </Tooltip>
            <span style={{ verticalAlign: 'middle', paddingTop: '4px' }}>%</span>
          </div>
        </div>
      </div>
      <div />
    </div>
  ) : (
    <div />
  );
};
